import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { PLAIN_WIDGET_FOR_DESIGN_PLAIN_QUERY } from "./schema";

export const usePlainWidgetQuery = (hotelID: string) => {
	const { data } = useCustomSuspenseQuery(PLAIN_WIDGET_FOR_DESIGN_PLAIN_QUERY, { variables: { hotelID } });

	return {
		data,
	};
};
